import * as React from 'react';
import { memo } from 'react';

const Triangle = () => <div className="a-triangle" />;

export { Triangle };
export default memo(Triangle);
